import {
    Button,
    createStyles,
    Grid,
    makeStyles,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Typography,
} from '@material-ui/core';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import T from 'src/components/content-manager/translator/T';
import Currency from 'src/components/elements/formats/Currency';
import { useAppMeta } from 'src/core/provider/AppMeta';
import { getShippingCostTable } from 'src/store/shipping-cost-table/selectors';

const useStyles = makeStyles(theme =>
    createStyles({
        table: {
            '& th': {
                fontWeight: theme.typography.fontWeightBold,
                color: theme.palette.primary.main,
            },
            '& thead th': {
                borderColor: theme.palette.primary.main,
            },
        },
        showMore: {
            textAlign: 'center',
            marginTop: theme.spacing(4),
        },
    })
);

interface ShippingCostTableProps {}

const ShippingCostTable: React.FC<ShippingCostTableProps> = () => {
    const classes = useStyles();
    const { t } = useTranslation();
    const { selectedRegionKey } = useAppMeta();
    const [showMore, setShowMore] = useState(false);
    const shippingCostTable = useSelector(getShippingCostTable);

    const toggleShowMore = () => {
        setShowMore(!showMore);
    };

    return (
        <Grid container spacing={4} direction="column">
            <Grid item xs={12}>
                <Typography variant="h3" color="primary" gutterBottom>
                    <T k="shop.shipping_cost_table_discover.heading" />
                </Typography>
                <Typography variant="body3" component="p">
                    <T k="shop.shipping_cost_table_discover.body" />
                </Typography>
            </Grid>
            {shippingCostTable.content
                ?.getSortedTablesByRegion(selectedRegionKey)
                .slice(0, showMore ? undefined : 1)
                .map(table => (
                    <Grid item xs={12} key={table.key}>
                        <Table className={classes.table}>
                            <TableHead>
                                <TableRow>
                                    <TableCell />
                                    {table.minCartValue.map((mcv, i) => (
                                        <TableCell key={i} align="right">
                                            {t('shop.shipping_cost_table_discover.from')}
                                            &nbsp;
                                            <Currency amount={mcv} currencyIso={table.currencyIso} />
                                        </TableCell>
                                    ))}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {table
                                    .getSortedZonesByRegion(selectedRegionKey)
                                    .slice(0, showMore ? undefined : 1)
                                    .map((zone, i) => (
                                        <TableRow key={i}>
                                            <TableCell variant="head" component="th">
                                                {zone.countryIso2List.join(', ')}
                                            </TableCell>
                                            {zone.fees.map((fee, i) => (
                                                <TableCell key={i} align="right">
                                                    <Currency amount={fee} currencyIso={table.currencyIso} />
                                                </TableCell>
                                            ))}
                                        </TableRow>
                                    ))}
                            </TableBody>
                        </Table>
                    </Grid>
                ))}
            <Grid item xs={12} className={classes.showMore}>
                <Button onClick={toggleShowMore} variant="contained">
                    {showMore ? (
                        <T k="shop.shipping_cost_table_discover.show_less" />
                    ) : (
                        <T k="shop.shipping_cost_table_discover.show_more" />
                    )}
                </Button>
            </Grid>
        </Grid>
    );
};

export default ShippingCostTable;
